module.exports = __webpack_public_path__ + "img/xd.207a6b48.svg";